import React from 'react';
import { AuthState } from '../AuthState';
import { baseStyles, createInputStyle } from '../styles';
import { FieldProps } from '../types';
import { useClinicianSignUp } from '../hooks/useClinicianSignUp';

import PinSection from './clinicianSignUp/PinSection';
import TenanciesSection from './clinicianSignUp/TenanciesSection';
import Consent from './clinicianSignUp/Consent';
import SubmitButton from './clinicianSignUp/SubmitButton';

const Field = React.forwardRef<HTMLInputElement, FieldProps>(
  ({ label, type, value, disabled }, ref) => {
    return (
      <input
        placeholder={label}
        ref={ref}
        type={type}
        style={createInputStyle('form')}
        value={value}
        disabled={disabled}
      />
    );
  },
);

Field.displayName = 'Field';

const ClinicianSignUpForm: React.FC = () => {
  const {
    clinicsState,
    selectedTenancyCount,
    isLoading,
    pin,
    confirmPin,
    firstNameRef,
    lastNameRef,
    referralCodeRef,
    handleChange,
    pinUpdated,
    confirmPinUpdated,
    handleSubmit,
    isFetchingData,
  } = useClinicianSignUp();

  return (
    <form
      style={{
        ...baseStyles.clientReg,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
        width: '80%',
      }}
      onSubmit={handleSubmit}
    >
      {/* Fixed header section */}
      <div style={{ flexShrink: 0, padding: '20px 0' }}>
        <h3>New user registration</h3>
        <div>
          <Field ref={firstNameRef} label="First Name" type="text" />
          <Field ref={lastNameRef} label="Last Name" type="text" />
          <Field ref={referralCodeRef} label="Referral Code" type="text" />
        </div>
        {/*  PIN input component for optional PIN setup */}
        {AuthState.tempPass && (
          <PinSection
            pinUpdated={pinUpdated}
            confirmPinUpdated={confirmPinUpdated}
            pin={pin}
            confirmPin={confirmPin}
          />
        )}
      </div>
      {/* Scrollable middle section for TenanciesSection */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '0 20px',
          minHeight: 0,
        }}
      >
        <TenanciesSection
          isFetchingData={isFetchingData}
          clinicsState={clinicsState}
          selectedTenancyCount={selectedTenancyCount}
          handleChange={handleChange}
        />
        <div className="d-flex flex-column gap-2 mt-2 mb-5">
          <Consent />
          <SubmitButton isLoading={isLoading} />
        </div>
      </div>
    </form>
  );
};

export { ClinicianSignUpForm };
